// extracted by mini-css-extract-plugin
export default {"pagination":"PaginationComp_pagination__DyZug","pageBtn":"PaginationComp_pageBtn__iTX6b","active":"PaginationComp_active__vyb59","ellipsis":"PaginationComp_ellipsis__dxTRG"};